export default {
  navigation: {
    title: "Settings",
    subtitle: "Configure your GenIaC workspace"
  },
  quickActions: {
    title: "Quick Actions",
    viewUsage: "View usage",
    manageSubs: "Manage subscription",
    viewInvoices: "View invoices"
  },
  search: {
    placeholder: "Search settings..."
  },
  menu: {
    connections: {
      label: "Cloud Connections",
      description: "Manage your cloud provider connections"
    },
    users: {
      label: "Users",
      description: "User management and synchronization"
    },
    teams: {
      label: "Teams",
      description: "Manage your work teams"
    },
    groups: {
      label: "Groups",
      description: "Organize your users into teams"
    },
    permissions: {
      label: "Permissions",
      description: "Configure roles and their access"
    },
    devops: {
      label: "DevOps Service",
      description: "CI/CD integrations and pipelines"
    },
    subscription: {
      label: "Subscription",
      description: "Manage your subscription and billing"
    },
    usage: {
      label: "Usage & Quotas",
      description: "Track your usage and manage quotas"
    },
    byoo: {
      label: "BYOO Azure DevOps",
      description: "Your own Azure DevOps organization"
    },
    whiteLabel: {
      label: "White Label",
      description: "Customize with your brand"
    },
    paymentMethods: {
      label: "Payment Methods",
      description: "Manage your credit cards"
    },
    invoices: {
      label: "Invoices",
      description: "View and download your invoices"
    },
    gdpr: {
      label: "Data & Privacy",
      description: "Manage your personal data (GDPR)"
    },
    admin: {
      label: "Admin Dashboard",
      description: "Metrics, subscriptions and revenue"
    }
  },
  welcome: {
    title: "Welcome to Settings",
    connections: {
      title: "Cloud Connections",
      description: "Configure your Azure, AWS and GCP connections"
    },
    users: {
      title: "Users",
      description: "Manage access and sync your directories"
    },
    teams: {
      title: "Teams",
      description: "Organize your work teams"
    },
    devops: {
      title: "DevOps Service",
      description: "Integrate your CI/CD pipelines"
    },
    subscription: {
      title: "Subscription",
      description: "Manage your plan and billing"
    },
    usage: {
      title: "Usage & Quotas",
      description: "Track your resource consumption and manage quotas"
    },
    paymentMethods: {
      title: "Payment Methods",
      description: "Manage your credit cards and payment methods"
    },
    invoices: {
      title: "Invoices",
      description: "View and download your invoices"
    },
    admin: {
      title: "Admin Dashboard",
      description: "Platform metrics, subscriptions and revenue"
    }
  },
  connections: {
    header: {
      title: "Connection Services",
      subtitle: "Configure your cloud provider connections"
    },
    buttons: {
      newConnection: "New connection",
      addConnection: "Add connection"
    },
    empty: {
      title: "No connections",
      subtitle: "Add your first cloud connection"
    },
    providers: {
      azure: "Microsoft Azure",
      aws: "Amazon Web Services",
      gcp: "Google Cloud Platform"
    },
    types: {
      servicePrincipal: "Service Principal",
      managedIdentity: "Managed Identity",
      oauth: "OAuth 2.0",
      sshKey: "SSH Key",
      apiKey: "API Key"
    },
    status: {
      connected: "Connected",
      failed: "Failed",
      testing: "Testing..."
    },
    labels: {
      status: "Status",
      lastTested: "Last tested",
      subscriptionId: "Subscription ID"
    },
    menu: {
      test: "Test connection",
      edit: "Edit",
      delete: "Delete"
    },
    time: {
      justNow: "Just now",
      minutesAgo: "{{count}} min ago",
      hoursAgo: "{{count}}h ago",
      daysAgo: "{{count}}d ago"
    },
    deleteConfirm: "Are you sure you want to delete this connection?",
    modal: {
      titleEdit: "Edit connection",
      titleNew: "New connection",
      nameLabel: "Connection name *",
      namePlaceholder: "Ex: Azure Production",
      providerLabel: "Cloud provider *",
      typeLabel: "Connection type",
      azureTitle: "Azure Information",
      awsTitle: "AWS Information",
      gcpTitle: "GCP Information",
      tenantId: "Tenant ID",
      clientId: "Client ID",
      clientSecret: "Client Secret",
      subscriptionId: "Subscription ID",
      accessKeyId: "Access Key ID",
      secretAccessKey: "Secret Access Key",
      region: "Region",
      projectId: "Project ID",
      serviceAccountKey: "Service Account Key (JSON)",
      cancel: "Cancel",
      save: "Save",
      create: "Create connection",
      nameRequired: "Connection name is required"
    }
  },
  users: {
    header: {
      title: "Users",
      subtitle: "Manage users and sync with your identity providers"
    },
    buttons: {
      sync: "Sync",
      newUser: "New user"
    },
    search: {
      placeholder: "Search for a user..."
    },
    table: {
      user: "User",
      role: "Role",
      provider: "Provider",
      groups: "Groups",
      actions: "Actions"
    },
    roles: {
      Admin: "Admin",
      Developer: "Developer",
      Viewer: "Viewer"
    },
    providers: {
      Local: "Local",
      "Azure AD": "Azure AD",
      "AWS IAM": "AWS IAM",
      "GCP IAM": "GCP IAM"
    },
    menu: {
      edit: "Edit",
      delete: "Delete"
    },
    deleteConfirm: "Delete this user?",
    modal: {
      titleEdit: "Edit user",
      titleNew: "New user",
      fullName: "Full name",
      email: "Email",
      role: "Role",
      provider: "Provider",
      cancel: "Cancel",
      save: "Save"
    },
    syncModal: {
      title: "Sync users",
      providerLabel: "Identity provider",
      info: "Users will be imported from {{provider}} with their roles and groups.",
      cancel: "Cancel",
      sync: "Sync",
      syncing: "Syncing...",
      successAlert: "{{provider}} sync completed - {{count}} users imported"
    }
  },
  groups: {
    header: {
      title: "Groups",
      subtitle: "Organize your users into teams with inherited permissions"
    },
    buttons: {
      newGroup: "New group"
    },
    card: {
      members: "{{count}} members"
    },
    menu: {
      edit: "Edit",
      delete: "Delete"
    },
    deleteConfirm: "Delete the group \"{{name}}\"?",
    modal: {
      titleEdit: "Edit group",
      titleNew: "New group",
      groupName: "Group name",
      description: "Description",
      permissions: "Permissions",
      cancel: "Cancel",
      save: "Save"
    },
    demo: {
      administrators: {
        name: "Administrators",
        description: "System administrators with all rights"
      },
      developers: {
        name: "Developers",
        description: "Development team"
      },
      viewers: {
        name: "Viewers",
        description: "Read-only access"
      }
    }
  },
  permissions: {
    header: {
      title: "Permissions",
      subtitle: "Manage roles and their permissions on projects"
    },
    buttons: {
      newRole: "New role"
    },
    card: {
      users: "{{count}} users"
    },
    menu: {
      edit: "Edit",
      delete: "Delete"
    },
    deleteConfirm: "Delete the role \"{{name}}\"?",
    modal: {
      titleEdit: "Edit role",
      titleNew: "New role",
      roleName: "Role name",
      description: "Description",
      permissions: "Permissions",
      permissionLabels: {
        read: "Read",
        write: "Write",
        delete: "Delete",
        deploy: "Deploy",
        manage_projects: "Manage projects",
        manage_users: "Manage users",
        admin: "Full administration"
      },
      cancel: "Cancel",
      save: "Save"
    },
    demo: {
      admin: {
        name: "Admin",
        description: "Full access to all features"
      },
      developer: {
        name: "Developer",
        description: "Development and deployment access"
      },
      viewer: {
        name: "Viewer",
        description: "Read-only access"
      }
    }
  },
  devops: {
    header: {
      title: "DevOps",
      subtitle: "Configure your Azure DevOps organization for repository and pipeline management"
    },
    success: {
      title: "Connection successful",
      subtitle: "Organization configured and accessible"
    },
    scenarios: {
      existing: {
        title: "Existing organization",
        description: "Connect to an existing Azure DevOps organization",
        icon: "🔗"
      },
      create: {
        title: "Create organization",
        description: "Create a new dedicated organization",
        icon: "➕"
      },
      shared: {
        title: "Shared organization",
        description: "Use a shared organization with a dedicated project",
        icon: "👥"
      }
    },
    configTitle: {
      existing: "existing",
      create: "new",
      shared: "shared"
    },
    fields: {
      orgUrl: "Organization URL *",
      orgUrlPlaceholder: "https://dev.azure.com/your-organization",
      orgUrlHint: "(e.g.: https://dev.azure.com/your-org)",
      pat: "Personal Access Token (PAT) *",
      patPlaceholder: "••••••••••••••••",
      patHint: "PAT must have permissions: Code (Read & Write), Build (Read & Execute)",
      orgName: "Organization name *",
      orgNamePlaceholder: "my-organization",
      orgNameUrlHint: "URL will be: https://dev.azure.com/{{orgName}}",
      projectName: "Dedicated project name *",
      projectNamePlaceholder: "GenIaC-Project"
    },
    info: {
      title: "Important information",
      createMessage: "A new Azure DevOps organization will be automatically created upon save. You will need to authenticate with a Microsoft account."
    },
    buttons: {
      test: "Test connection",
      testing: "Testing...",
      save: "Save"
    },
    help: {
      title: "How to get a Personal Access Token?",
      step1: "Go to Azure DevOps → User Settings → Personal Access Tokens",
      step2: "Click on \"New Token\"",
      step3: "Give it a name and select scopes: Code (Read & Write), Build (Read & Execute)",
      step4: "Copy the generated token and paste it above"
    },
    alert: {
      saved: "DevOps configuration saved"
    }
  },
  subscription: {
    header: {
      title: "Subscription",
      subtitle: "Manage your subscription and billing"
    },
    billingCycle: {
      monthly: "Monthly",
      yearly: "Yearly",
      discount: "-17%",
      monthShort: "month",
      yearShort: "year",
      savings: "Save {{amount}}€ /year"
    },
    badges: {
      popular: "Popular",
      current: "Current"
    },
    viewUsageLink: "View my usage and quotas →",
    buttons: {
      choosePlan: "Choose this plan",
      currentPlan: "Current plan",
      contactUs: "Contact us"
    },
    price: {
      free: "Free",
      contactUs: "Contact us",
      perMonth: "/month",
      perYear: "/year",
      yearlyDiscount: "or {{amount}}€/year (-20%)"
    },
    limits: {
      title: "LIMITS",
      projects: "Projects",
      architectures: "Architectures",
      deploymentsPerMonth: "Deployments/month",
      unlimited: "Unlimited",
      unlimitedFem: "Unlimited"
    },
    paymentMethod: {
      title: "Payment method",
      noCardRequired: "No credit card required for the free plan",
      upgradeHint: "Upgrade to a paid plan to add your payment method",
      manageDescription: "Manage your payment methods and view invoices through the secure Stripe portal",
      manageButton: "Manage my subscription"
    },
    billingHistory: {
      title: "Billing history",
      noInvoices: "No invoices available",
      status: {
        paid: "Paid",
        open: "Pending",
        draft: "Draft",
        void: "Void",
        uncollectible: "Uncollectible"
      }
    },
    plans: {
      free: {
        name: "Free",
        features: [
          "5 projects max",
          "10 resources per project",
          "Community support",
          "Basic Terraform export",
          "1GB storage"
        ]
      },
      standard: {
        name: "Standard",
        features: [
          "3 projects",
          "50 architectures",
          "30 deployments/month",
          "Email support",
          "Terraform export",
          "Azure DevOps integration",
          "10GB storage",
          "90 days history"
        ]
      },
      entreprise: {
        name: "Enterprise",
        features: [
          "Unlimited projects",
          "Unlimited architectures",
          "Unlimited deployments",
          "Priority support + SLA",
          "Auto-provisioning DevOps",
          "SSO / SAML",
          "Audit logs",
          "Unlimited storage",
          "365 days history"
        ]
      },
      pro: {
        name: "Pro",
        features: [
          "Unlimited projects",
          "Unlimited resources",
          "24/7 priority support",
          "Daily automatic backup",
          "Advanced Terraform + modules",
          "CI/CD integration",
          "50GB storage",
          "Multi-cloud (Azure, AWS, GCP)",
          "90 days history"
        ]
      },
      enterprise: {
        name: "Enterprise",
        features: [
          "All Pro +",
          "SSO / SAML",
          "Complete audit logs",
          "Dedicated support + CSM",
          "99.9% SLA",
          "Isolated environments",
          "Compliance & security",
          "Unlimited storage",
          "Unlimited history",
          "Custom training"
        ]
      }
    },
    features: {
      projects: "{{count}} projects",
      architectures: "{{count}} architectures",
      deployments: "{{count}} deployments/month",
      unlimitedProjects: "Unlimited projects",
      unlimitedArchitectures: "Unlimited architectures",
      unlimitedDeployments: "Unlimited deployments",
      azureDevOps: "Auto-provisioning Azure DevOps",
      prioritySupport: "Priority support"
    },
    checkout: {
      title: "Choose your plan",
      subtitle: "Select the plan that best fits your needs",
      currentPlan: "Current plan",
      recommended: "Recommended",
      free: "Free",
      perMonth: "month",
      perYear: "year",
      saveAmount: "Save €{{amount}} per year ({{percentage}}% off)",
      billingCycle: {
        monthly: "Monthly",
        yearly: "Yearly (save 20%)"
      },
      buttons: {
        cancel: "Cancel",
        proceed: "Proceed to payment",
        processing: "Processing..."
      },
      errors: {
        samePlan: "You are already on this plan",
        cannotDowngradeToFree: "Please contact support to downgrade to Free plan",
        generic: "An error occurred. Please try again."
      },
      securityNotice: "Secure payment powered by Stripe. Your payment information is encrypted and secure."
    },
    paymentModal: {
      title: "Confirm subscription",
      subtitle: "You are about to subscribe to the plan:",
      cardNumber: "Card number",
      cardNumberPlaceholder: "1234 5678 9012 3456",
      expiration: "Expiration",
      expirationPlaceholder: "MM/YY",
      cvv: "CVV",
      cvvPlaceholder: "123",
      cancel: "Cancel",
      confirm: "Confirm",
      alert: "Subscription to {{planName}} plan confirmed!"
    }
  },
  teams: {
    header: {
      title: "Teams",
      subtitle: "Manage your work teams and their members"
    },
    buttons: {
      newTeam: "New Team",
      createFirstTeam: "Create your first team",
      viewDetails: "View details"
    },
    empty: {
      title: "No teams",
      subtitle: "Create your first team to better organize your work"
    },
    demo: {
      infrastructure: {
        name: "Infrastructure",
        description: "Team in charge of cloud infrastructure"
      },
      security: {
        name: "Security",
        description: "Team responsible for security and compliance"
      },
      application: {
        name: "Application",
        description: "Application development team"
      }
    },
    card: {
      members: "Members",
      projects: "Projects",
      projectsList: "Assigned projects",
      teamLeads: "Team leads",
      more: "more"
    },
    menu: {
      manageMembers: "Manage members",
      edit: "Edit",
      delete: "Delete"
    },
    deleteConfirm: "Are you sure you want to delete the team {{name}}?",
    modal: {
      titleEdit: "Edit team",
      titleNew: "New team",
      teamName: "Team name",
      teamNamePlaceholder: "Ex: Cloud Infrastructure",
      description: "Description",
      descriptionPlaceholder: "Describe the role of this team...",
      color: "Color",
      cancel: "Cancel",
      save: "Save",
      create: "Create team",
      nameRequired: "Team name is required"
    },
    membersModal: {
      subtitle: "{{count}} member(s)",
      addMember: "Add member",
      memberName: "Full name",
      memberEmail: "Email",
      memberRole: "Role",
      roles: {
        member: "Member",
        teamLead: "Team Lead"
      },
      cancel: "Cancel",
      add: "Add",
      close: "Close",
      noMembers: "No members in this team"
    }
  },
  invoices: {
    header: {
      title: "Invoices",
      subtitle: "View and download your invoice history"
    },
    refresh: "Refresh",
    loading: "Loading invoices...",
    empty: {
      title: "No invoices",
      description: "You don't have any invoices yet. They will appear here after your first payment."
    },
    error: {
      title: "Loading error",
      retry: "Retry"
    },
    stats: {
      totalBilled: "Total billed",
      pending: "Pending",
      paidCount: "Paid invoices",
      totalInvoices: "Total invoices"
    },
    filters: {
      search: "Search by number...",
      allStatuses: "All statuses",
      paid: "Paid",
      open: "Pending",
      void: "Voided",
      uncollectible: "Uncollectible",
      allDates: "All dates",
      lastMonth: "Last month",
      last3Months: "Last 3 months",
      thisYear: "This year",
      clearFilters: "Clear filters",
      resultsCount: "{{count}} invoice(s) found",
      statusLabel: "Status",
      periodLabel: "Period",
      searchLabel: "Search"
    },
    noResults: {
      title: "No results",
      description: "No invoices match your search criteria.",
      resetFilters: "Reset filters"
    },
    table: {
      date: "Date",
      number: "Number",
      status: "Status",
      amount: "Amount",
      actions: "Actions"
    },
    status: {
      paid: "Paid",
      open: "Pending",
      void: "Voided",
      uncollectible: "Uncollectible",
      draft: "Draft"
    },
    actions: {
      view: "View",
      viewOnline: "View invoice online",
      downloadPdf: "Download PDF"
    },
    footer: {
      showing: "Showing {{filtered}} of {{total}} invoice(s)",
      totalDisplayed: "Total displayed"
    },
    info: {
      title: "About invoices",
      autoGenerated: "Invoices are automatically generated with each subscription renewal",
      emailSent: "You also receive an email with the invoice at your billing address",
      pdfAvailable: "PDFs are stored and accessible at any time from this page",
      contact: "For any questions about an invoice, contact"
    }
  },
  paymentMethods: {
    header: {
      title: "Payment Methods",
      subtitle: "Manage your credit cards for recurring payments"
    },
    addCard: "Add a new card",
    savedCards: "Saved cards",
    loading: "Loading...",
    empty: {
      title: "No payment method",
      description: "Add a credit card to subscribe to a paid plan.",
      cta: "Add my first card"
    },
    card: {
      expires: "Expires",
      expired: "Expired",
      default: "Default",
      setDefault: "Set as default",
      delete: "Delete"
    },
    brands: {
      visa: "Visa",
      mastercard: "Mastercard",
      amex: "American Express",
      unknown: "Card"
    },
    addModal: {
      title: "Add a credit card",
      cardDetails: "Card information",
      cancel: "Cancel",
      add: "Add card",
      adding: "Adding...",
      securePayment: "Secure payment by Stripe"
    },
    deleteModal: {
      title: "Delete card",
      message: "Are you sure you want to delete this card?",
      cardInfo: "{{brand}} ending in {{last4}}",
      warning: "This action cannot be undone.",
      cancel: "Cancel",
      delete: "Delete",
      deleting: "Deleting..."
    },
    toast: {
      addSuccess: "Card added successfully",
      addError: "Error adding card",
      deleteSuccess: "Card deleted successfully",
      deleteError: "Error deleting card",
      setDefaultSuccess: "Card set as default",
      setDefaultError: "Error setting default card",
      loadError: "Error loading payment methods"
    },
    info: {
      title: "Information",
      secureStorage: "Your payment information is securely stored by Stripe",
      defaultCard: "The default card will be used for automatic renewals",
      multipleCards: "You can add multiple cards and change the default at any time"
    }
  },
  cancellation: {
    title: "Cancel subscription",
    steps: {
      reason: "Reason",
      offers: "Offers",
      feedback: "Feedback",
      confirm: "Confirmation"
    },
    reasonStep: {
      title: "We're sad to see you go",
      subtitle: "Could you tell us why you want to cancel?",
      reasons: {
        too_expensive: "Too expensive for my budget",
        not_using_enough: "I'm not using the service enough",
        missing_features: "Missing features",
        switching_competitor: "Switching to a competitor",
        temporary_pause: "Temporary project pause",
        company_closing: "Company closing",
        other: "Other reason"
      }
    },
    offersStep: {
      title: "Before you go...",
      subtitle: "We have special offers for you!",
      applying: "Applying...",
      discount: {
        title: "{{percent}}% discount",
        description: "Get {{percent}}% off your next month's subscription.",
        accept: "Accept offer"
      },
      pause: {
        title: "Pause for {{days}} days",
        description: "Pause your subscription for {{days}} days without losing your data or settings.",
        accept: "Pause subscription"
      },
      downgrade: {
        title: "Switch to Standard plan",
        description: "Keep access to GenIaC with a lower-cost plan instead of canceling completely.",
        accept: "Change plan"
      },
      notInterested: "Not interested in these offers?",
      continueCancel: "Continue cancellation"
    },
    feedbackStep: {
      title: "Help us improve",
      subtitle: "Your feedback is valuable to us (optional)",
      selectedReason: "Selected reason",
      additionalComments: "Additional comments",
      placeholder: "Share your suggestions or what we could have done differently...",
      reminder: {
        title: "Important reminder",
        message: "Your subscription will remain active until {{date}}. After this date, you will automatically switch to the free plan."
      }
    },
    confirmStep: {
      title: "Confirm cancellation",
      subtitle: "This action is final",
      summary: {
        currentPlan: "Current plan",
        reason: "Reason",
        endDate: "Access ends"
      },
      consequences: {
        title: "What will happen:",
        cancelAtEnd: "Your subscription will be canceled at the end of the period",
        switchToFree: "You will switch to the free plan with its limitations",
        projectsArchived: "Projects exceeding quotas will be archived",
        canResubscribe: "You can resubscribe at any time"
      }
    },
    buttons: {
      back: "Back",
      cancel: "Cancel",
      continue: "Continue",
      confirm: "Confirm cancellation",
      cancelling: "Cancelling..."
    }
  },
  usage: {
    header: {
      title: "Usage & Quotas",
      subtitle: "Track your consumption and manage your quotas"
    },
    currentPlan: "Current plan",
    billingPeriod: "Billing period",
    resources: {
      projects: "Projects",
      architectures: "Architectures",
      deployments: "Deployments this month",
      storage: "Storage",
      users: "Users",
      pipelineMinutes: "CI/CD Minutes"
    },
    usage: {
      used: "used",
      of: "of",
      unlimited: "unlimited"
    },
    alerts: {
      approaching: "You're approaching the limit",
      exceeded: "Limit exceeded",
      upgrade: "Upgrade to a higher plan for more capacity",
      limitReached: "Limit reached",
      critical: "Critical",
      warning: "Warning",
      moderate: "Moderate",
      ok: "OK"
    },
    upgrade: {
      title: "Need more?",
      description: "Upgrade to a higher plan to unlock more resources",
      button: "View plans"
    },
    overview: "Overview",
    remaining: "remaining",
    remainingPlural: "remaining",
    usedPercent: "{{percent}}% used",
    resetsAt: "Resets {{date}}",
    thisMonth: "This month",
    history: {
      title: "Usage history",
      days7: "7 days",
      days30: "30 days",
      days90: "90 days",
      pipelineTitle: "CI/CD minutes consumed"
    },
    trial: {
      active: "Trial period active",
      expiringSoon: "Trial period expiring soon",
      expired: "Trial period expired",
      expiredMessage: "Your free trial has expired. Upgrade to a paid plan to continue using GenIaC.",
      daysRemaining: "{{days}} of your free trial remaining.",
      choosePlan: "Choose a plan",
      upgradeNow: "Upgrade now"
    },
    noData: "No subscription data available",
    refresh: "Refresh",
    upgradeButton: "Upgrade",
    loading: "Loading...",
    error: {
      title: "Loading error",
      retry: "Retry"
    },
    upgradeSuggestion: {
      title: "Upgrade to {{plan}} plan",
      button: "View plans"
    }
  },
  byoo: {
    header: {
      title: "BYOO Azure DevOps",
      subtitle: "Bring Your Own Organization - Use your own Azure DevOps organization"
    },
    loading: "Loading...",
    infoBanner: {
      title: "Feature reserved for BUSINESS plan",
      description: "Configure your own Azure DevOps organization for full control over your projects. You will need a Personal Access Token (PAT) with permissions:",
      permissions: "Project and Team (Read, Write, & Manage)"
    },
    status: {
      validated: "Configuration validated",
      notValidated: "Configuration not validated",
      organization: "Organization",
      lastValidated: "Last validated"
    },
    errors: {
      businessOnly: "This feature is only available for the BUSINESS plan.",
      loadFailed: "Error loading configuration",
      required: "Organization URL and Personal Access Token are required",
      saveFailed: "Error saving configuration",
      testFailed: "Error testing connection",
      deleteFailed: "Error deleting configuration"
    },
    success: {
      title: "Success",
      testSuccess: "{{message}} - {{count}} projects found"
    },
    error: {
      title: "Error"
    },
    config: {
      title: "Configuration",
      subtitleNew: "Configure your Azure DevOps organization",
      subtitleEdit: "Update your BYOO configuration"
    },
    form: {
      orgUrl: "Azure DevOps organization URL *",
      orgUrlPlaceholder: "https://dev.azure.com/YourOrganization",
      orgUrlHint: "Format: https://dev.azure.com/YourOrganization",
      pat: "Personal Access Token (PAT) *",
      patPlaceholder: "Enter your PAT",
      patPlaceholderKeep: "Leave empty to keep current PAT",
      patHint: "PAT must have permissions:",
      patCurrent: "Current PAT",
      namingPattern: "Project naming pattern",
      namingPatternHint: "Available variables: {orgSlug}, {projectName}, {userId}, {date}",
      subscriptionId: "Azure Subscription ID (optional)",
      defaultLocation: "Default Azure region"
    },
    buttons: {
      test: "Test",
      testing: "Testing...",
      save: "Save",
      update: "Update",
      saving: "Saving...",
      delete: "Delete",
      deleting: "Deleting..."
    },
    deleteConfirm: "Are you sure you want to delete the BYOO configuration? This action is irreversible.",
    help: {
      title: "How to create a Personal Access Token?",
      steps: [
        "Go to dev.azure.com",
        "Click on your avatar > User Settings > Personal Access Tokens",
        "Click \"New Token\"",
        "Give the token a name and select your organization",
        "Set the expiration (recommended: 90 days or more)",
        "In Scopes, select: Project and Team (Read, Write, & Manage)",
        "Click \"Create\" and copy the generated token",
        "Paste the token in the field above"
      ]
    }
  },
  whiteLabel: {
    header: {
      title: "White Label",
      subtitle: "Customize the interface with your brand"
    },
    loading: "Loading...",
    infoBanner: {
      title: "Feature reserved for BUSINESS plan",
      description: "Customize GenIaC's appearance with your logo, colors, and text. Changes will be visible to all users in your organization."
    },
    status: {
      active: "White Label active",
      inactive: "White Label disabled",
      lastModified: "Last modified"
    },
    errors: {
      businessOnly: "This feature is only available for the BUSINESS plan.",
      loadFailed: "Error loading configuration",
      invalidPrimaryColor: "Invalid primary color. Required format: #RRGGBB",
      invalidSecondaryColor: "Invalid secondary color. Required format: #RRGGBB",
      invalidAccentColor: "Invalid accent color. Required format: #RRGGBB",
      saveFailed: "Error saving configuration",
      resetFailed: "Error resetting configuration",
      deleteFailed: "Error deleting configuration"
    },
    success: {
      title: "Success"
    },
    error: {
      title: "Error"
    },
    config: {
      title: "Configuration",
      subtitle: "Customize your platform appearance"
    },
    branding: {
      title: "Branding",
      appName: "Application name",
      companyName: "Company name",
      companyNamePlaceholder: "My Company",
      logoUrl: "Logo URL",
      logoUrlPlaceholder: "https://example.com/logo.png or data:image/png;base64,...",
      logoUrlHint: "Public URL or data URL (base64)",
      faviconUrl: "Favicon URL",
      faviconUrlPlaceholder: "https://example.com/favicon.ico"
    },
    colors: {
      title: "Colors",
      primary: "Primary color",
      secondary: "Secondary color",
      accent: "Accent color"
    },
    content: {
      title: "Content",
      welcomeMessage: "Welcome message",
      welcomeMessagePlaceholder: "Welcome to our customized IaC platform",
      footerText: "Footer text",
      footerTextPlaceholder: "© 2026 My Company - All rights reserved",
      supportEmail: "Support email",
      supportEmailPlaceholder: "support@mycompany.com",
      supportUrl: "Support URL",
      supportUrlPlaceholder: "https://support.mycompany.com"
    },
    advanced: {
      title: "Advanced",
      customDomain: "Custom domain",
      customDomainPlaceholder: "iac.mycompany.com",
      customDomainHint: "Requires DNS configuration",
      hideBranding: "Hide \"Powered by GenIaC\" mention"
    },
    buttons: {
      save: "Save",
      saving: "Saving...",
      reset: "Reset",
      resetting: "Resetting...",
      disable: "Disable",
      disabling: "Deleting..."
    },
    confirmReset: "Are you sure you want to reset the configuration to default values?",
    confirmDelete: "Are you sure you want to disable White Label configuration? This action is reversible.",
    preview: {
      title: "Color preview",
      primary: "Primary",
      secondary: "Secondary",
      accent: "Accent"
    }
  },
  gdpr: {
    title: "Data & Privacy (GDPR)",
    subtitle: "Manage your personal data and exercise your rights under GDPR",
    exportTitle: "Export my data",
    exportDescription: "Download a complete copy of all your data stored in GenIaC in JSON format (Article 20 GDPR - Right to data portability).",
    dataIncluded: {
      personalInfo: "Personal and contact information",
      organization: "Organization details",
      subscriptions: "Subscriptions and billing history",
      projects: "Projects and configurations",
      architectures: "Cloud architectures",
      deployments: "Deployments history",
      invoices: "Invoices and payments",
      usage: "Usage metrics and statistics"
    },
    exportButton: "Download my data",
    exporting: "Preparing export...",
    exportSuccess: "Your data has been downloaded successfully!",
    exportError: "Error exporting data. Please try again later.",
    deleteTitle: "Delete my account",
    deleteDescription: "Permanently delete your account and all associated data (Article 17 GDPR - Right to be forgotten).",
    deleteWarningTitle: "This action is irreversible!",
    deleteWarning: "Once confirmed, your account and all your data will be permanently deleted. You will receive a confirmation email with a secure link to complete the deletion.",
    deletionEffects: {
      projects: "All your projects and architectures will be deleted",
      architectures: "All infrastructure configurations will be deleted",
      subscriptions: "Your active subscription will be cancelled",
      invoices: "Invoices will be anonymized (7-year legal retention)"
    },
    deleteButton: "Delete my account",
    processing: "Processing...",
    deleteEmailSent: "A confirmation email has been sent. Check your inbox and click the link to confirm deletion within 24 hours.",
    deletionError: "Error requesting account deletion. Please try again later.",
    confirmDeleteTitle: "Confirm account deletion",
    confirmDeleteMessage: "Are you absolutely sure you want to delete your account? This action cannot be undone. You will receive a confirmation email.",
    confirmDelete: "Yes, delete my account",
    cancel: "Cancel"
  }
};
